export default __webpack_public_path__ + "navigation-overview-carplay-960-5fd524dd48fc0e5bb1f275d023260e51.webp";